/** Chest rarity names for reward chips ("Legendary chest"). */
export const CHEST_LABEL = ["Common", "Uncommon", "Rare", "Epic", "Legendary", "Mythic"] as const;
